import useIsMobile from "../../../hooks/useIsMobile";
import ErrorBanner from "../../../components/ErrorPage/ErrorBanner";
import Head from "next/head";
import Image from "next/image";
import CommanContentBanner from "../../../components/commanContentBanner";
import CommonHomeCard from "../../../components/commonHomeCard";
import { configuration } from "../../../helpers/config";
import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactPlayer from "react-player";
import GetQuoteStyle from "../../../components/get-quote/GetQuote.module.css";
import DynamicFormComponent from "../../../components/forms/dynamic-form/DynamicFormComponent";
import FAQ from "../../../components/Faq";
import { useSelector } from "react-redux";
import { Constants } from "../../../helpers/constants";
import DisclaimerTag from "../../../components/DisclaimerTags/DisclaimerTag/DisclaimerTag";

// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";


export default function GenericTemplate(props) {
  const { data, error } = props;
  const isMobile = useIsMobile();
  const [formData, setFormData] = useState();
  const LOB_VALUE = useSelector((state) => state?.app?.LobValue);
  const reduxData = useSelector(({ app }) => app); 
  const [isLoading, setIsLoading] = useState(true);
  const [hideImage, setHideImage] = useState(false);
  const [isLoadingMobile, setIsLoadingMobile] = useState(true);
    const [isPlaying, setIsPlaying] = useState(true);
    const [showInfo, setShowInfo] = useState(false);
    
    const togglePlayPause = () => {
      setIsPlaying(!isPlaying);
    };

  const disclaimerSetting = useSelector((state) => state?.app?.disclaimerSetting);
  
  let isTitlePresent = data?.primary_details?.title ? true : false; 
  let isTitleVisible = data?.primary_details?.title_visibility ? true : false;

  useEffect(() => {
    if (!configuration.API_LOB) return; 
    const dealerCode = reduxData.dealerCode != undefined && reduxData.dealerCode != null && reduxData.dealerCode? reduxData.dealerCode : localStorage.getItem("dealercode");
    if (dealerCode != "") {
      (async () => {
        try {
          const res = await axios.get(
            `${configuration.APP_URL_CONTENTS}/forms?lob=${configuration.API_LOB}&dealer_code=${dealerCode}`,
            configuration.HEADER_DEALER_LOCATOR_VAPT,
          );
          let requiredForm = res.data[0]?.forms.filter(
            (form) => form.form_name === props?.data?.forms,
          )[0];
          setFormData(requiredForm);
        } catch (e) {
          //console.log(e.message);
        }
      })();
    }
  }, [LOB_VALUE]);

  if (error) {
    return (
      <ErrorBanner
        image={`${configuration.IMG_STATIC_URL}errorBanner.png`}
        imageMob={`${configuration.IMG_STATIC_URL}errorMob.png`}
        error="404"
        desc="Sorry, the page you’re looking for doesn’t exist"
        btn="Go Back"
      />
    );
  }

  return (
    <div>
      <Head>
        <title>{data?.seo_settings?.meta_title}</title>
        <meta name="description" content={data?.seo_settings?.meta_desc} />
        <meta name="keywords" content={data?.seo_settings?.keywords} />
        <meta name="keywords" content={data?.seo_settings?.keywords} />

        {configuration?.COUNTRY_CODE=="PH" && props?.data?.primary_details?.slug=="get-a-quote-form"&&
        <>
               <script
  dangerouslySetInnerHTML={{
    __html: `
      window.addEventListener('load', function () {
        if (typeof gtag === 'function') {
          gtag('event', 'conversion_event_submit_lead_form', {
            // <event_parameters>
          });
        }
      });
    `,
  }}
/>



        </>}
      </Head>
      <div className="relative brand__banner bg-defaut-color">
        <div className="block md:hidden mobile_banner">
         

          {data?.mobile_video? (
             <div className="block lg:hidden" style={{ position: "relative", width: "100%", height: "60vh" }}>
               <ReactPlayer
              url={ data?.mobile_video? `${configuration.IMG_URL}${data?.mobile_video}` : "" }
              playing={isPlaying}
              volume={0}
              height="100%"
              width="100%"
              loop={true}
              playsinline
             
            />
                    
                        {/* Play/Pause Button */}
                        <button
              onClick={togglePlayPause}
              style={{
                position: "absolute",
                bottom: "110px",
                right: "90px",
                backgroundColor: "white",
                color: "black",
                border: "2px solid #001151",
                borderRadius: "50%", // Circular
                cursor: "pointer",
                zIndex: 1,
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight:"10px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.10)"
              }}
            >
              <img
                src={
                  isPlaying
                    ? `${configuration.IMG_STATIC_URL}pause.svg`
                    : `${configuration.IMG_STATIC_URL}Play.svg`
                }
                alt={isPlaying ? "Pause" : "Play"}
                style={{ width: "24px", height: "24px" }}
              />
            </button>
                    
                        {/* Info Button */}
                        <button
              onClick={() => setShowInfo(true)}
              style={{
                position: "absolute",
                bottom: "112px",
                right: "20px",
                backgroundColor: "white",
                color: "black",
                border: "2px solid #001151",
                cursor: "pointer",
                zIndex: 1,
                width: "68px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.10)"
              }}
            >
          {Constants.allcomponents.INFO}
            </button>
                    
                        {/* Info Modal */}
                        {showInfo && (
                          <div
                            style={{
                              position: "absolute",
                              top: "40%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              backgroundColor: "#fff",
                              padding: "20px",
                              // borderRadius: "10px",
                              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                              zIndex: 10,
                              width: "300px",
                              height:"300px",
                            }}
                          >
                            <div className="flex align">
                <p style={{ fontWeight: 400, fontFamily: "SuzukiPROBold", fontSize: "24px"  }}>{Constants.allcomponents.INFO_TITLE}</p>
                <button
                  onClick={() => setShowInfo(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "15px",
                    background: "none",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                 aria-label="Close"
                >
               <span aria-hidden="true" role="presentation">×</span>
                </button>
                </div>
                            <div style={{
                     marginTop:"15px",
                     fontSize: "16px",
                     fontWeight: "400",
                     fontFamily: "SuzukiPROBold",
                    
                  }}>
                              
                              <p style={{overflow:"scroll",height:"220px"}}>{props?.data?.mobile_video_info}</p>
                            </div>
                          </div>
                        )}
                        <div className="mp_overlay_banner light-grad"></div>
                      </div>
           
          ) : (
            <div style={{ position: "relative", height: "60vh" }}> 
            {/* {isLoadingMobile && !hideImage && <Skeleton height={1080} width={768} />} */}
            {!hideImage && (
            <Image
               src={ data?.images?.mob_banner? `${configuration.IMG_URL}${data?.images?.mob_banner}` : "" }
              // layout="fill"
              // objectFit="cover"
              alt={data?.images?.mob_banner_alt1 || (data?.images?.mob_banner ? `Suzuki_${data?.images?.mob_banner?.split("/").pop()?.split(".")[0]}` : "")}
              // height={!isLoadingMobile ?1080:0}
              // width={ !isLoadingMobile ? 768:0}
              layout="fill"
              objectFit="cover" 
              className={isLoadingMobile ? "hidden" : "block"}
              onError={() => setHideImage(true)}
              onLoad={() => setIsLoadingMobile(false)}
            />
          )}
          <div className="mp_overlay_banner light-grad"></div>
            </div>
          )}
        </div>

        <div className="hidden md:block">
          {data?.video ? (
             <div style={{ position: "relative", width: "100%", height: "calc(100vh - 180px)" }}>
                          <ReactPlayer
              url={data?.video? `${configuration.IMG_URL}${data?.video}` : "" }
              playing={isPlaying}
              volume={0}
              height={"calc(100vh - 180px)"}
              width={"100%"}
              loop={true}
              playsinline
              
            />
                    
                        {/* Play/Pause Button */}
                        <button
                          onClick={togglePlayPause}
                          style={{
                            position: "absolute",
                bottom: "20px",
                right: "90px",
                padding:"6px",
                backgroundColor: "white",
                color: "black",
                border: "2px solid #001151", 
                borderRadius: "50px",
                cursor: "pointer",
                zIndex: 1,
                marginRight:"10px",
                          }}
                        >
                          <img
                            src={
                              isPlaying
                                ? `${configuration.IMG_STATIC_URL}pause.svg`
                                : `${configuration.IMG_STATIC_URL}Play.svg`
                            }
                            alt={isPlaying ? "Pause" : "Play"}
                            style={{ width: "24px", height: "24px" }}
                          />
                        </button>
                    
                        {/* Info Button */}
                        <button
                          onClick={() => setShowInfo(true)}
                          style={{
                            position: "absolute",
                            bottom: "23px",
                            right: "20px",
                            backgroundColor: "white",
                            color: "black",
                            border: "2px solid #001151", 
                            
                            cursor: "pointer",
                            zIndex: 1,
                            height:"36px",
                            width:"68px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                       <span>{Constants.allcomponents.INFO}</span>
                        </button>
                    
                        {/* Info Modal */}
                        {showInfo && (
                          <div
                            style={{
                              position: "absolute",
                              top: "40%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              backgroundColor: "#fff",
                              padding: "20px",
                              // borderRadius: "10px",
                              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                              zIndex: 10,
                              width: "700px",
                            }}
                          >
                             <div className="flex align">
              <p style={{ fontWeight: 400, fontFamily: "SuzukiPROBold", fontSize: "24px"  }}>{Constants.allcomponents.INFO_TITLE}</p>
                <button
                  onClick={() => setShowInfo(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "15px",
                    background: "none",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                  aria-label="Close"
                 >
              <span aria-hidden="true" role="presentation">×</span>
                </button>
                </div>
                            <div style={{
                     marginTop:"20px",
                     fontSize: "16px",
                     fontWeight: "400",
                     fontFamily: "SuzukiPROBold",
                    
                  }}>
                              
                              <p>{props?.data?.desktop_video_info}</p>
                            </div>
                          </div>
                        )}
                        <div className="mp_overlay_banner light-grad"></div>
                      </div>
          
          ) : (
            <div style={{ position: "relative", height: "calc(100vh - 180px)" }}>  
               {/* {isLoading && !hideImage && <Skeleton height={1004} width={1928} />} */}
               {!hideImage && (
            <Image
              src={ data?.images?.desk_banner? `${configuration.IMG_URL}${data?.images?.desk_banner}`: ""}
              alt={data?.images?.desk_banner_alt1 || (data?.images?.desk_banner ? `Suzuki_${data?.images?.desk_banner?.split("/").pop()?.split(".")[0]}` : "")}
              // height={!isLoading ?1004:0}
              // width={!isLoading?1928:0}
              layout="fill"
              objectFit="cover" 
              onLoad={() => setIsLoading(false)}
              onError={() => setHideImage(true)}
            />
               )}
               <div className="mp_overlay_banner light-grad"></div>
            </div>

          )}
        </div>
      
        <div className="container mx-auto ">
          <div className="brand__banner--position">
            {isTitlePresent && isTitleVisible ? (
            <h2
              className={`uppercase font-suzukiBold text-heading42 md:text-bannerHeading  text-inverted md:mb-0 lg:mb-[0] xl:mb-[0px] mt-[50px]`}
              // style={
              //   windoWidth.width > 1024
              //     ? {
              //         fontSize: themeSetting?.model_title_font_size,
              //         color: themeSetting?.model_title_color,
              //       }
              //     : { color: themeSetting?.model_title_color }
              // }
            >
              {data?.primary_details?.banner_title} 
            </h2>
            ) : (
              <h1
              className={`uppercase font-suzukiBold text-heading42 md:text-bannerHeading  text-inverted mb-[5px] md:mb-0 lg:mb-[0] xl:mb-[0px]`}>
              {data?.primary_details?.banner_title} 
            </h1>
            )}
            </div>
            </div>
        </div>
        {disclaimerSetting && disclaimerSetting?.publishedValue && (
             <DisclaimerTag 
              disclaimerData={data?.disclaimers || null}
              type="slide"
        /> )}  
       <div className="get-quote-descript container md:max-w-[500px] lg:max-w-[900px] mb-[100px] mt-[50px]">
        <h2 className="md:text-[24px] lg:text-[24px] text-[18px] text-center" 
         dangerouslySetInnerHTML={{ __html: data?.primary_details?.desc }}
         >
        </h2>
        
      </div>


      <div className="mt-[50px] container">
     
        <div className={GetQuoteStyle.get__quote__container}>
        {data?.primary_details?.title_visibility && (
          <h1 className="text-sub-heading font-suzukiBold mb-[28px] uppercase text-defaut-color">
            {data?.primary_details?.title}
          </h1>
        )}
        {formData && (
          <DynamicFormComponent
            hidetitle={true}
            data={formData}
            onClose={() => {
              // console.log("finished")
            }}
          />
        )}
        </div>
      </div>
      <div className="mt-8">
      <FAQ faq_data={props.data}/>
      </div>
      {data?.primary_details?.tnc && (
          <div
          className="container unreset wordwrap"
          id="cms_form_pages_t&c"
            // className={`unreset my-10 sm:w-[90%] container ${
            //   !isBannerVisible && "mt-[100px]"
            // } ${newData?.fleet?.order_index === null ? "lg:w-[50%]" : ""}`}
            dangerouslySetInnerHTML={{
              __html: data?.primary_details?.tnc,
            }}
          />
        )}
    </div>
  
  );
}